import { WorkflowsRootState } from '../ducks.types';

export const getIsFetchingBetaNodes = (state: WorkflowsRootState) =>
  state.workflow?.isFetchingBetaNodes;
export const getBetaSupportedNodes = (state: WorkflowsRootState) =>
  state.workflow?.betaNodes?.supported || [];
